import { Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import CheckoutPage from "./pages/CheckoutPage";
import EventPage from "./pages/EventPage";
import HomePage from "./pages/HomePage";
import SearchPage from "./pages/SearchPage";

export default function App() {
  return (
    <div className="app">
      <Header />
      <main className="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/events/:id" element={<EventPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      <footer className="footer">
        <div className="container">
          <span>tickets · demo build · powered by mock data</span>
        </div>
      </footer>
    </div>
  );
}
